/**
 * Tipos de autenticação que a credencial de um scraper aceita, e quais
 * deles cada scraper sabe usar.
 *
 * Espelho de `core.spreadsheet.template.SCRAPER_AUTH_KINDS` e
 * `SCRAPER_AUTH_KINDS_BY_SCRAPER` (o `core/` é o dono; paridade por FONTE
 * em `tests/test_scraper_auth_kinds_parity.py`). "Nenhuma autenticação"
 * não é valor: é a ausência da credencial.
 */
export const SCRAPER_AUTH_KINDS = ["login_password", "api_token"] as const;

export type ScraperAuthKind = (typeof SCRAPER_AUTH_KINDS)[number];

export const SCRAPER_AUTH_KINDS_BY_SCRAPER: Record<string, readonly ScraperAuthKind[]> = {
  boxnet: [],
  clipei: ["login_password"],
  cwa: [],
  info4: [],
  fabrica: [],
  knewin: [],
  linear: []
};

export const SCRAPER_AUTH_KIND_LABELS: Record<ScraperAuthKind, string> = {
  login_password: "Login e senha",
  api_token: "Token de API"
};

/** Os tipos que o scraper aceita; vazio = o scraper não usa credencial. */
export function authKindsFor(scraper: string | null | undefined): readonly ScraperAuthKind[] {
  return scraper ? (SCRAPER_AUTH_KINDS_BY_SCRAPER[scraper] ?? []) : [];
}
